var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Curved/Video"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Video"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    d: "M16.1514 9.67278C17.9895 8.21564 20.4561 6.80611 20.9228 7.31087C21.6942 8.13945 21.6276 16.0252 20.9228 16.7775C20.4942 17.2442 18.0085 15.8347 16.1514 14.3871",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5144 12.0369C2.5144 6.84449 4.23917 5.11401 9.41536 5.11401C14.5906 5.11401 16.3154 6.84449 16.3154 12.0369C16.3154 17.2283 14.5906 18.9597 9.41536 18.9597C4.23917 18.9597 2.5144 17.2283 2.5144 12.0369Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideos);
export default __webpack_public_path__ + "static/media/videos.8ab371f928bc2133e55da1e6d0cee58e.svg";
export { ForwardRef as ReactComponent };